<template>
    <div v-if="record.is_visible === true && record.status === 'in_union'">
        <TooltipIcon :text="$t('data_published')" icon-cls="info" />
        <span class="ml-1 kp-dimmed-text">{{ $t('released') }}</span>
    </div>
    <div v-else-if="record.is_visible === true && record.status === 'requested'">
        <TooltipIcon :text="$t('data_requested')" icon-cls="info" />
        <span class="ml-1 kp-dimmed-text">{{ $t('publication_requested') }}</span>
    </div>
    <div v-else>
        <TooltipIcon :text="$t('data_not_published')" icon-cls="info" />
        <span class="ml-1 kp-dimmed-text">{{ $t('not_released') }}</span>
    </div>
</template>

<script>
import { Address } from '@/models/Address';
export default {
    props: {
        record: {
            type: Address,
            required: true,
        },
    },
};
</script>
